import { render } from "./Category.vue?vue&type=template&id=282366e4&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=282366e4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-282366e4"

export default script